import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {} from 'vue'
import { useRouter } from 'vue-router'
import { ImagePreview } from 'vant'
import AppHeader from '@/components/Header.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'power-of-attorney',
  setup(__props) {

const $router = useRouter()
const imgeSrc = 'https://static.knowledge.xag.cn/doc/agricultura-loan/power-if-attorney-img.png'

function back() {
  $router.go(-1)
}

function previewHandle() {
  ImagePreview({
    images: [imgeSrc],
    startPosition: 0,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "授权书" }),
    _createElementVNode("div", { class: "img-list" }, [
      _createElementVNode("img", {
        src: imgeSrc,
        alt: "",
        onClick: previewHandle
      })
    ]),
    _createVNode(CommonFooterNextButton, {
      title: "返回",
      onClick: back
    })
  ], 64))
}
}

})